export const getVerificationPermissions = (verificationData, fiscalYear) => {
  const permissions = { canDelete: true, canEdit: true, reason: null };
  if (!verificationData) return { canDelete: false, canEdit: false, reason: 'Verifikatet kunde inte läsas.' };

  if (verificationData.isAnnulmentVerification) {
    return {
      canDelete: false,
      canEdit: false,
      reason: 'Detta är ett annulleringsverifikat och kan inte ändras.',
    };
  }

  if (verificationData.hasBeenAnnulled) {
    return {
      canDelete: false,
      canEdit: false,
      reason: 'Detta verifikat har redan annullerats.',
    };
  }

  if (verificationData.invoice) {
    return {
      canDelete: false,
      canEdit: false,
      reason: 'Verifikatet är kopplat till en faktura och hanteras från fakturavyn.',
    };
  }

  const references = verificationData.references;
  const sourceReferences = Array.isArray(references)
    ? references
    : references?.asSource || [];
  const targetReferences = Array.isArray(references)
    ? references
    : references?.asTarget || [];

  if (sourceReferences.some((reference) => reference.reference_type === 'customer_invoice_payment')) {
    return {
      canDelete: false,
      canEdit: false,
      reason: 'Verifikatet är kopplat till en fakturabetalning och hanteras från fakturavyn.',
    };
  }

  if (sourceReferences.some((reference) => reference.reference_type === 'payment_reversal')) {
    return {
      canDelete: false,
      canEdit: false,
      reason: 'Verifikatet är kopplat till en annullerad betalning och kan inte ändras.',
    };
  }

  if (targetReferences.some((reference) => reference.reference_type === 'verification_reversal')) {
    return {
      canDelete: false,
      canEdit: false,
      reason: 'Verifikatet har redan annullerats.',
    };
  }

  const fiscalYearState = fiscalYear?.state
    || verificationData.fiscal_year_state
    || verificationData.fiscalYear?.state;
  if (fiscalYearState === 'closed') {
    const fiscalYearLabel = fiscalYear?.year || verificationData.fiscal_year;
    return {
      canDelete: false,
      canEdit: false,
      reason: fiscalYearLabel
        ? `Räkenskapsår ${fiscalYearLabel} är låst.`
        : 'Räkenskapsåret är låst.',
    };
  }

  return permissions;
};
